import React from "react";
import { MessageCircle } from "lucide-react";
const WhatsappLogo = MessageCircle;
import { HOMESTAY } from "@/lib/data";

export default function WhatsAppFAB() {
  const href = `https://wa.me/${HOMESTAY.contact.whatsapp}?text=${encodeURIComponent(
    "Hi Mrinmaya team, I'd like to enquire about a stay at your vacation home near Nandi Hills."
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-4 md:bottom-24 md:right-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb955] text-white rounded-full shadow-lg shadow-black/20 pl-3 pr-4 py-3 transition-transform hover:-translate-y-0.5"
    >
      <WhatsappLogo size={22} fill="currentColor" />
      <span className="text-sm font-medium hidden sm:block">Chat</span>
    </a>
  );
}
